import { render } from "./mat-icon-button.vue?vue&type=template&id=0bc7ce6f&scoped=true&lang=true"
import script from "./mat-icon-button.vue?vue&type=script&lang=js"
export * from "./mat-icon-button.vue?vue&type=script&lang=js"

import "./mat-icon-button.vue?vue&type=style&index=0&id=0bc7ce6f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc7ce6f"]])

export default __exports__